export const REJECT_TEXT_STORAGE_KEY = "rejectedApplicationText";
export const AFFILIATES_FILTER_STORAGE_KEY = "affiliatesFilter";
export const TOKEN_STORAGE_KEY = "token";